import { Icon } from '@hologram-dimension/icon';
import { Modal } from '@hologram-dimension/modal';
import { useState, type FC } from 'react';
import type { CommonModalProps } from '../shared';
import styles from './OrgAcceptedInvite.module.css';

interface OrgAcceptedInviteProps extends CommonModalProps {
  orgName: string;
}

const OrgAcceptedInvite: FC<OrgAcceptedInviteProps> = ({
  onClose,
  orgName,
  defaultOpen = false,
  className,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Modal
      className={className}
      noContentPadding
      header="Accepted invite"
      onClosed={onClose}
      open={open}
      setOpen={setOpen}
    >
      <div className={styles.contentsWrapper}>
        <Icon name="CircleCheckmark" fill="DdsColorFillNotificationSuccess" size="large" />
        <div className={styles.contents}>
          <div className={styles.contentHeader}>You joined {orgName}</div>
          <div className={styles.contentText}>
            {
              'Change organizations in the top right corner of your dashboard, or change your default organization under Settings > Your Account.'
            }
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OrgAcceptedInvite;
